import { render, staticRenderFns } from "./MarketingBanner.vue?vue&type=template&id=5329f182&scoped=true&"
import script from "./MarketingBanner.vue?vue&type=script&lang=js&"
export * from "./MarketingBanner.vue?vue&type=script&lang=js&"
import style0 from "./MarketingBanner.vue?vue&type=style&index=0&id=5329f182&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5329f182",
  null
  
)

export default component.exports